import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full px-4 md:px-6 py-24 flex flex-col items-center justify-center text-center">
      <p className="text-7xl md:text-9xl font-black text-background-300 select-none">404</p>
      <h1 className="text-xl md:text-2xl font-bold text-foreground-900 mt-4 mb-2">页面走丢了</h1>
      <p className="text-sm text-foreground-500 mb-1">你访问的页面不存在或已被移除。</p>
      <p className="text-xs text-foreground-400 font-mono mb-6">{location.pathname}</p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
        >
          浏览电影
        </Link>
      </div>
    </div>
  );
}